const $ = window.jQuery;

let s = {
	body : $('body'),
	push : $('.js-push'),

	pushMenuSwitch : 833,

	// menuToggle         : $('.js-menu__toggle'),
	menuToggleSelector : '.js-menu__toggle',

	// menuClose         : $('.js-menu__close'),
	menuCloseSelector : '.js-menu__toggle',
	
	// Focus management
	lastFocusedElement : null,
	focusableElements : 'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select',
};

function init() {
	events();
}

/* ---------------------------------------
   Helpers for arrow-key navigation only
   --------------------------------------- */

// Visible check so we don’t focus hidden submenu items
function isVisible(el) {
	if (!el) return false;
	if (el.hidden) return false;
	const style = window.getComputedStyle(el);
	if (style.display === 'none' || style.visibility === 'hidden') return false;
	// If ancestor is display:none, offsetParent will be null (except for fixed)
	if (el.offsetParent === null && style.position !== 'fixed') return false;
	// Guard against hidden/inert ancestors
	let n = el.parentElement;
	while (n) {
		if (n.hidden) return false;
		const ns = window.getComputedStyle(n);
		if (ns.display === 'none' || ns.visibility === 'hidden') return false;
		n = n.parentElement;
	}
	return true;
}

// Focusable items for ARROW navigation (slightly broader than your Tab list)
// NOTE: We include [tabindex] so custom widgets (like the language switcher) are reachable via arrows.
// We DO NOT change your Tab selector; Tab behavior remains exactly as-is.
function getArrowNavItems() {
	const menu = document.querySelector('.o-mobile-menu');
	if (!menu) return [];
	return Array.from(
		menu.querySelectorAll(
			'a[href], button, [tabindex]:not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])'
		)
	).filter(isVisible);
}

function moveFocusBy(delta) {
	const items = getArrowNavItems();
	if (!items.length) return;

	// If nothing inside has focus, start at the first item
	const active = document.activeElement;
	let idx = items.indexOf(active);
	if (idx === -1) {
		items[0].focus();
		return;
	}

	let next = idx + delta;
	if (next < 0) next = items.length - 1;
	if (next >= items.length) next = 0;
	items[next].focus();
}

function focusFirstItem() {
	const items = getArrowNavItems();
	if (items[0]) items[0].focus();
}

function focusLastItem() {
	const items = getArrowNavItems();
	if (items.length) items[items.length - 1].focus();
}

/* ---------------------------------------
   Your existing focus trap (unchanged)
   --------------------------------------- */

// Focus trap functionality
function trapFocus() {
	// Get focusable elements from both the mobile menu and the toggle button
	const mobileMenu = document.querySelector('.o-mobile-menu');
	const menuFocusableElements = mobileMenu ? mobileMenu.querySelectorAll(s.focusableElements) : [];
	const toggleButton = document.querySelector(s.menuToggleSelector);
	
	// Combine menu elements with toggle button
	const allFocusableElements = Array.from(menuFocusableElements);
	if (toggleButton) {
		allFocusableElements.push(toggleButton);
	}
	
	const firstFocusableElement = allFocusableElements[0];
	const lastFocusableElement = allFocusableElements[allFocusableElements.length - 1];

	// Add event listener to document to capture all keyboard events
	document.addEventListener('keydown', function focusTrapHandler(e) {
		// Only handle tab events when menu is open
		if (!s.push.hasClass('push--active')) {
			return;
		}

		const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) {
			// Shift + Tab: going backwards
			if (document.activeElement === firstFocusableElement) {
				lastFocusableElement.focus();
				e.preventDefault();
			}
		} else {
			// Tab: going forwards
			if (document.activeElement === lastFocusableElement) {
				firstFocusableElement.focus();
				e.preventDefault();
			}
		}
	});
}

// Handle Escape key to close menu
function handleEscapeKey(event) {
	if (event.key === 'Escape' && s.push.hasClass('push--active')) {
		closeMenu();
	}
}

// Close menu function
function closeMenu() {
	const $toggle = $(s.menuToggleSelector);
	
	$toggle.removeClass('is-open');
	s.body.removeClass('no-scroll');
	s.push.removeClass('push--active');
	
	// Update ARIA attributes
	$toggle.attr('aria-expanded', 'false');
	$toggle.attr('aria-label', 'Open mobile menu');
	
	s.push.find('.push__level--top')
		.addClass('push__level--active')
		.addClass('push__level--current');

	setTimeout(function() {
		// close any open accordions
		$('.o-mobile-menu li.has-mega-menu').removeClass('dropdown-open');
		$('.menu__list .menu__list').hide();
		$('.o-mobile-menu li.has-mega-menu .mega-menu').hide();

		/** reset scroll */
		s.push
			.find('.push__level-inner')
			.scrollTop(0);

		/** reset active */
		s.push
			.find('.push__level--active')
			.removeClass('push__level--active');
			
		// Return focus to the toggle button
		if (s.lastFocusedElement) {
			s.lastFocusedElement.focus();
			s.lastFocusedElement = null;
		}
	}, 400); // transition
}

// Open menu function
function openMenu($toggle) {
	// Store the currently focused element
	s.lastFocusedElement = document.activeElement;
	
	$toggle.addClass('is-open');
	s.body.addClass('no-scroll');
	s.push.addClass('push--active');
	
	// Update ARIA attributes
	$toggle.attr('aria-expanded', 'true');
	$toggle.attr('aria-label', 'Close mobile menu');
	
	s.push.find('.push__level--top')
		.addClass('push__level--active')
		.addClass('push__level--current');
		
	// Set up focus trap and focus first focusable element
	setTimeout(function() {
		const mobileMenu = document.querySelector('.o-mobile-menu');
		if (mobileMenu) {
			trapFocus();
			
			// Focus the first focusable element in the menu (not the toggle button)
			const firstFocusable = mobileMenu.querySelector(s.focusableElements);
			if (firstFocusable) {
				firstFocusable.focus();
			}
		}
	}, 100); // Small delay to ensure menu is fully rendered
}

/* ---------------------------------------
   Events
   --------------------------------------- */

function events() {

	$(window).on('load resize', function() {

		if (window.innerWidth < s.pushMenuSwitch && s.push.hasClass('push--active')) {
			s.body.addClass('no-scroll');
		} else {
			s.body.removeClass('no-scroll');
		}
	});

	// Add keyboard event listener for Escape key
	document.addEventListener('keydown', handleEscapeKey);

	// Since toggle and close are the same element now, we need a single handler
	s.body.on('click', s.menuToggleSelector, function(event) {
		event.preventDefault();
		
		const $toggle = $(this);
		const isOpening = !s.push.hasClass('push--active');
		
		if (isOpening) {
			openMenu($toggle);
		} else {
			closeMenu();
		}
	});

	// Add keyboard event handling for the toggle button
	s.body.on('keydown', s.menuToggleSelector, function(event) {
		// Handle Enter and Space keys
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			
			const $toggle = $(this);
			const isOpening = !s.push.hasClass('push--active');
			
			if (isOpening) {
				openMenu($toggle);
			} else {
				closeMenu();
			}
		}
	});

	// Add event handling for skip navigation links to close mobile menu
	s.body.on('click', '.m-skip-navigation__link', function(event) {
		// If menu is open, close it when skip link is clicked
		if (s.push.hasClass('push--active')) {
			closeMenu();
		}
	});

	// Handle Enter key on skip navigation links
	s.body.on('keydown', '.m-skip-navigation__link', function(event) {
		// Only close menu if Enter key is pressed (not Tab)
		if (event.key === 'Enter' && s.push.hasClass('push--active')) {
			closeMenu();
		}
	});

	// accordion action - simplified to just toggle
	const menuItemsWithChildren = document.querySelectorAll('.o-mobile-menu .has-mega-menu > a');

	menuItemsWithChildren.forEach(function(menuItem) {
		menuItem.addEventListener('click', function(event) {
			// Always prevent navigation since we're making it toggle-only
			event.preventDefault();
			
			const parentLi = this.parentElement;
			const menuList = parentLi.querySelector('.mega-menu');
			
			if (menuList) {
				// Toggle the dropdown
				const isOpen = parentLi.classList.contains('dropdown-open');
				
				if (isOpen) {
					// Close it
					menuList.style.display = 'none';
					menuList.setAttribute('hidden', '');
					parentLi.classList.remove('dropdown-open');
					// Update ARIA attributes
					menuItem.setAttribute('aria-expanded', 'false');
					parentLi.setAttribute('aria-expanded', 'false');
				} else {
					// Open it
					menuList.style.display = 'block';
					menuList.removeAttribute('hidden');
					parentLi.classList.add('dropdown-open');
					// Update ARIA attributes
					menuItem.setAttribute('aria-expanded', 'true');
					parentLi.setAttribute('aria-expanded', 'true');
				}
			}
		});
	});

	/* ---------------------------------------
	   Arrow-key navigation inside the menu
	   (↑/↓, Home/End; ←/→ alias to ↑/↓)
	   --------------------------------------- */
	const mobileMenu = document.querySelector('.o-mobile-menu');
	if (mobileMenu) {
		mobileMenu.addEventListener('keydown', function(e) {
			// Only when the menu is open
			if (!s.push.hasClass('push--active')) return;

			switch (e.key) {
				case 'ArrowDown':
				case 'Right': // older key values
				case 'ArrowRight':
					e.preventDefault();
					moveFocusBy(+1);
					break;
				case 'ArrowUp':
				case 'Left':
				case 'ArrowLeft':
					e.preventDefault();
					moveFocusBy(-1);
					break;
				case 'Home':
					e.preventDefault();
					focusFirstItem();
					break;
				case 'End':
					e.preventDefault();
					focusLastItem();
					break;
				default:
					// let other keys pass
					break;
			}
		}, true); // capture to be reliable even if inner elements stop propagation
	}
}

export {init as default};
